module.exports = __webpack_public_path__ + "static/media/mimi8.6646a3de.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi8.gif
// module id = 300
// module chunks = 0